export const ErrorMessages = {
  Required: "Задължително поле",
  Number: "Трябва да въведете число",
  MinLength: "Трябва да въведете поне три символа",
  Date: "Трябва да въведете дата",
  UniquePairRequired: "Не може да се дублира с удостоверяване на подпис",
  AtLeastOneFilled: "Регистрационният номер на подпис или съдържание е задължително поле",
  AlreadyExists: "Номерът вече съществува",
  NotaryNumberExists: "Съществува активен нотариус с този номер",
  ExternalUserUsernameExists: "Съществува външен потребител с това потребителско име",
  MayorSettlementExists: "Съществува потребител, асоцииран към това населено място",
  BankNameExists: "Съществува банка с това име",
  BankBranchNameExists: "Съществува банков клон с това име",
  InvestmentBrokerNameExists: "Съществува инв. дружество с това име",
  InvestmentBrokerBranchNameExists: "Съществува клон на инв. дружество с това име",
  InsurerNameExists: "Съществува застрахователно дружество с това име",
  InsurerBranchNameExists: "Съществува клон на застрахователно дружество с това име",
  SecretKeyExists: "Секретният ключ вече е въведен в системата",
  VerificationThumbprintExists: "Сървърният сертификат вече е въведен в системата",
  ThumbprintExists: "Електронният подпис вече е въведен в системата",
  AuthorizationNotFound: "Не е намерено посоченото пълномощно",
  InvalidValue: "Невалидна стойност",
};

export const REGEX_NUMBER = /^[0-9]+$/;
export const REGEX_THUMBPRINT = /^[0-9a-fA-F]{40}$/;
export const REGEX_EMAIL =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export const IntMaxValue: number = 2147483647;

export const Rules = {
  Required: {
    required: ErrorMessages.Required,
  },
  Number: {
    validate: (number?: number) => {
      if (number) {
        if (!REGEX_NUMBER.test(number.toString())) {
          return ErrorMessages.Number;
        }
        if (number > IntMaxValue) {
          return ErrorMessages.InvalidValue;
        }
      }
    },
  },
  MinLength: {
    minLength: {
      value: 3,
      message: ErrorMessages.MinLength,
    },
  },
  Date: {
    validate: (date?: Date) => {
      const isValidDate = date ? !isNaN(date?.getTime()) : true;
      if (!isValidDate) {
        return ErrorMessages.Date;
      }
    },
  },
  Email: {
    pattern: {
      value: REGEX_EMAIL,
      message: ErrorMessages.InvalidValue,
    },
  },
  Password: (minLength: number, maxLength: number) => {
    return {
      validate: async (data: string) => {
        if (!(minLength <= data.length && data.length <= maxLength)) {
          return `Дължината на полето трябва да е между ${minLength} и ${maxLength} символа`;
        }
      },
    };
  },
  Thumbprint: {
    pattern: {
      value: REGEX_THUMBPRINT,
      message: ErrorMessages.InvalidValue,
    },
  },
};
